<div class="dialog-letter">

  <div class="card-div">
    <mat-dialog-content class="mat-typography">
      <h1 mat-dialog-title><app-brand-mark [size]="56"></app-brand-mark> {{ 'common.welcome' | t }}</h1>

      <div>
        <!-- <div class="alert alert-info">
        <img [src]="logo" width="50" height="50" [alt]="logo" />
      </div> -->
      <div class="card">
        <h1 class="card-header">{{ 'auth.loginTitle' | t }}</h1>
        <div class="card-body">
          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
              <label style="display: flex;" for="username">{{ 'common.email' | t }}</label>
              <input type="email" formControlName="username" class="form-control"
                [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
                @if (submitted && f.username.errors) {
                  <div class="invalid-feedback">
                    @if (f.username.errors.required) {
                      <div>{{ 'common.emailRequired' | t }}</div>
                    }
                    @if (f.username.errors.email) {
                      <div>{{ 'common.emailInvalid' | t }}</div>
                    }
                  </div>
                }
              </div>
              <div class="form-group">
                <label style="display: flex;" for="password">{{ 'common.password' | t }}</label>
                <input type="password" formControlName="password" class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                  @if (submitted && f.password.errors) {
                    <div class="invalid-feedback">
                      @if (f.password.errors.required) {
                        <div>{{ 'common.passwordRequired' | t }}</div>
                      }
                    </div>
                  }
                </div>
                <button [disabled]="loading" class="btn btn-primary" cdkFocusInitial >
                  @if (loading) {
                    <span class="spinner-border spinner-border-sm mr-1"></span>
                  }
                  {{ 'auth.loginButton' | t }}
                </button>

                @if (error) {
                  <div class="alert alert-danger mt-3 mb-0">{{error}}</div>
                }
              </form>
              <br>
                <a mat-flat-button (click)="openDialogForgotPassword()">
                  {{ 'auth.forgotPassword' | t }}
                </a>
              </div>
            </div>
          </div>
          <br>
            <button color="primary" (click)="openDialogInscription()" [mat-dialog-close]="true" mat-stroked-button>
              {{ 'auth.createAccount' | t }}
            </button>
          </mat-dialog-content>

        </div>
        <!-- <div class="card-div">
        <mat-dialog-content class="mat-typography">
          <h1 mat-dialog-title>Inscription</h1>

          <div>
            <div class="alert alert-info">
              Username: test<br />
              Password: test
            </div>
            <div class="card">
              <h4 class="card-header">Angular 10 Basic Authentication Example</h4>
              <div class="card-body">
                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                  <div class="form-group">
                    <label for="username">Username</label>
                    <input type="text" formControlName="username" class="form-control"
                      [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
                      <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                        <div *ngIf="f.username.errors.required">Username is required</div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="password">Password</label>
                      <input type="password" formControlName="password" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                          <div *ngIf="f.password.errors.required">Password is required</div>
                        </div>
                      </div>
                      <button [disabled]="loading" class="btn btn-primary">
                        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                        Login
                      </button>
                      <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
                    </form>
                  </div>
                </div>
              </div>




              <mat-slide-toggle><span>J'accepte de recevoir la newsletter de promodeep.com</span></mat-slide-toggle>
              <mat-slide-toggle><span>J'accepte de recevoir des publicités de nos partenaires</span></mat-slide-toggle>


              <br>
                <br>
                  <p>Vous affirmez pris connaissance de notre <a class="verySmallText" routerLink="privacyPolicy">Politique de
                  confidentialité.</a></p>
                  <br>
                    <h5>

                    </h5>
                  </mat-dialog-content>
                  <mat-dialog-actions align="end">

                  </mat-dialog-actions>
                </div> -->
              </div>
